const $ = jQuery.noConflict();

'use strict';
const Accordion = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domAccFooterShown: $('.js-box-shown'),
	$domAccFooterHidden: $('.js-box-hidden'),
	$domAccordionShown: $('.js-accordion__box-shown'),
	$domAccordionHidden: $('.js-accordion__box-hidden'),
	$domAccBlockShown: $('.js-block-lists-shown'),
	// $domAccBlockHidden: $('.js-block-lists-hidden'),
	$domAccSearchIcon: $('.js-search-block-icon'),
	$domAccSearchHidden: $('.js-search-block-hidden'),
	$domTabsDropdown: $('.js-tabs-dropdown'),
	$domTabsDropdownHidden: $('.js-tabs-dropdown-hidden'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		this.accordionFooter();
		this.accordionAcc();
		// this.accordionAccBlockLists();
		this.accordionAccSearchBlock();
		this.tabsDropdown();
		this.clickOutsideClose();
		$('.page-navigation__link').mouseover(function() {
			$(this).addClass('js-show-link');
		});
		$('.page-navigation__link').mouseout(function() {
			$(this).removeClass('js-show-link');
		});
	},

	/** @description Bind Events */
	accordionFooter: function() {
		Accordion.$domAccFooterShown.each(function(e, el) {
			$(el).on('click', function() {
				const _self = $(this);
				if (_self.parent().hasClass(Accordion.classActive)) {
					_self.parent().removeClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccFooterHidden).slideUp();
				} else {
					_self.parent().addClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccFooterHidden).slideDown();
					_self.parent().siblings().removeClass(Accordion.classActive).find(Accordion.$domAccFooterHidden).slideUp();
				}
			});
		});
	},

	accordionAcc: function() {
		Accordion.$domAccordionShown.each(function(e, el) {
			$(el).on('click', function() {
				const _self = $(this);
				if (_self.parent().hasClass(Accordion.classActive)) {
					_self.parent().removeClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccordionHidden).slideUp();
				} else {
					_self.parent().addClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccordionHidden).slideDown();
					_self.parent().siblings().removeClass(Accordion.classActive).find(Accordion.$domAccordionHidden).slideUp();
				}
			});
		});
	},

	// accordionAccBlockLists: function() {
	// 	Accordion.$domAccBlockShown.each(function(e, el) {
	// 		$(el).on('click', function() {
	// 			const _self = $(this);
	// 			if (_self.parent().hasClass(Accordion.classActive)) {
	// 				_self.parent().removeClass(Accordion.classActive);
	// 				_self.siblings(Accordion.$domAccBlockHidden).slideUp();
	// 			} else {
	// 				_self.parent().addClass(Accordion.classActive);
	// 				_self.siblings(Accordion.$domAccBlockHidden).slideDown();
	// 				_self.parent().siblings().removeClass(Accordion.classActive).find(Accordion.$domAccBlockHidden).slideUp();
	// 			}
	// 		});
	// 	});
	// },

	accordionAccSearchBlock: function() {
		Accordion.$domAccSearchIcon.each(function(e, el) {
			$(el).on('click', function() {
				const _self = $(this);
				if (_self.parent().hasClass(Accordion.classActive)) {
					_self.parent().removeClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccSearchHidden).slideUp();
				} else {
					_self.parent().addClass(Accordion.classActive);
					_self.siblings(Accordion.$domAccSearchHidden).slideDown();
					_self.parent().siblings().removeClass(Accordion.classActive).find(Accordion.$domAccSearchHidden).slideUp();
				}
			});
		});
	},

	tabsDropdown: function() {
		Accordion.$domTabsDropdown.on('click', function() {
			if (!Accordion.$domTabsDropdown.hasClass(Accordion.classActive)) {
				Accordion.$domTabsDropdown.addClass(Accordion.classActive);
				Accordion.$domTabsDropdownHidden.slideDown();
			} else {
				Accordion.$domTabsDropdown.removeClass(Accordion.classActive);
				Accordion.$domTabsDropdownHidden.slideUp();
			}
		});
	},

	clickOutsideClose: function() {
		$(document).on('mouseup', function(e) {
			let container = Accordion.$domTabsDropdown;
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				Accordion.$domTabsDropdownHidden.slideUp();
			}
		});
		$(document).on('keyup', function(e) {
			if (e.keyCode === 27) {
				Accordion.$domTabsDropdownHidden.slideUp();
			}
		});
	},
};

export default Accordion;